import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useWindowSize from 'hooks/useWindowSize';
import { H6 } from 'components/Typography';
import Avatar from 'products/global/views/Profile/components/CustomizeAvatar/components/Avatar';
import { th } from 'style/theme';
import { SCREEN_SIZES } from 'style';
import FemaleAvatar from 'products/global/assets/img/gender/female.png';
import MaleAvatar from 'products/global/assets/img/gender/male.png';

export const StyledAvatar = styled(Avatar)`
  top: 3px;
`;

export const AvatarWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

export const AvatarContainer = styled.div`
  width: 34px;
  height: 34px;
  background-color: ${({ background }) => background || 'transparent'};
  background-image: url(${({ src }) => src});
  background-size: cover;
  border-radius: 50%;
  margin-right: 10px;
  position: relative;

  ::before {
    content: '';
    transition: 0.3s;
    z-index: -1;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background-color: ${th('colors.white')};
  }
`;

export const AvatarContainerMobile = styled.div`
  display: flex;
  align-items: center;

  > h6 {
    color: ${th('colors.white')};
  }
`;

export const AvatarMobile = styled.img`
  border-radius: 50%;
  margin-right: 14px;
  width: 60px;
  height: 60px;
`;

const AvatarIcon = ({ avatar, gender, firstName, lastName }) => {
  const { width } = useWindowSize();

  if (width >= SCREEN_SIZES.desktop) {
    return (
      <AvatarContainer src={!avatar ? gender : null} background={avatar?.background}>
        {avatar && (
          <AvatarWrapper>
            <StyledAvatar config={avatar} />
          </AvatarWrapper>
        )}
      </AvatarContainer>
    );
  }
  return (
    <AvatarContainerMobile>
      <AvatarMobile src={gender === 'female' ? FemaleAvatar : MaleAvatar} />
      {firstName && lastName && <H6>{`${firstName} ${lastName}`}</H6>}
    </AvatarContainerMobile>
  );
};

AvatarIcon.propTypes = {
  avatar: PropTypes.object,
  gender: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string
};

export default AvatarIcon;
